/**
 * Admin guide 3 — reading the stats: SMSWiser per drop (paced, re-read for
 * a few hours), one tracker report per campaign, cached multi-day ranges.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DropGenEngineSettings } from '@trafficpulse/shared';

import { seconds } from '../../settings/section-draft';
import { Flow, Points, V } from '../guide-ui';

export const StatsSection: FC<{ s: DropGenEngineSettings }> = ({ s }) => (
  <div className="flex flex-col gap-3">
    <Flow
      stamp="One drop's numbers"
      steps={[
        { when: 'After its send', what: 'Settles', how: 'A drop counts only after its settle time.' },
        { when: <>Every {s.verdictEveryMin} min</>, what: 'SMSWiser read', how: <>Up to <V>{s.statsReadsPerPass}</V> drops a container, <V>{seconds(s.statsPaceMs)}</V> apart.</> },
        { when: <>Every {s.statsRereadMin} min</>, what: 'Read again', how: <>Until <V>{s.statsFreshHours} h</V> after the send — then final.</> },
        { when: 'Same pass', what: 'Judged', how: 'Missing numbers are "not judged yet", never a FAIL.' },
      ]}
    />
    <Points
      items={[
        <><b>Today, per drop</b> (SMSWiser: sent, delivered, clicks) — settled drops first; a refusal (429) ends the reads of that pass and keeps the last numbers.</>,
        <><b>Today, tracker</b> (Voluum / Binom) — one report per container's campaign per pass.</>,
        <><b>Several days</b> (text, hour, list and gateway rankings; verdicts on the list's stats) — one tracker report per date range, from the cache (section 7).</>,
      ]}
    />
  </div>
);
